"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _ErgoTopLevelView = _interopRequireDefault(require("./ErgoTopLevelView.scss"));

var _KESI2Helper = _interopRequireDefault(require("../../../../KESI2/KESI2Helper"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../../helpers/CordovaFileHelper"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _DataStoreComponent2 = _interopRequireDefault(require("../../DataStoreComponent/DataStoreComponent2"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../../NavigationManagerCordova"));

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _PreconditionChecker = require("../../../../utils/PreconditionChecker");

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _RemoteControlService = require("../../../../KESI2/Services/RemoteControlService");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var riskRingId = 'targetRing';
var IMAGE_ID = 'targetShield_background_image_';
var STATIC_IMAGE_ID = 'targetShield_static_background_image';

var NewsFeed = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(NewsFeed, _DataStoreComponent);

  var _super = _createSuper(NewsFeed);

  function NewsFeed(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, NewsFeed);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeIndex", function (currentIndex) {
      _this.setState({
        newsIndex: currentIndex
      });

      var images = (0, _toConsumableArray2["default"])(document.getElementsByClassName(_ErgoTopLevelView["default"].imageContainer));
      images.forEach(function (image, index) {
        image.classList.remove(_ErgoTopLevelView["default"].imageContainerNoTrans);

        if (index === _this.state.newsIndex) {
          image.style.opacity = 1;
        } else {
          image.style.opacity = 0;
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSwitching", function (index) {
      _this.setState({
        arrowsVisible: false
      });

      var currentIndex = _this.state.newsIndex;
      var newIndex = null;

      if (index > currentIndex) {
        newIndex = currentIndex + 1;
      } else if (index < currentIndex) {
        newIndex = currentIndex - 1;
      } else {
        _this.setState({
          arrowsVisible: true
        });

        var images = (0, _toConsumableArray2["default"])(document.getElementsByClassName(_ErgoTopLevelView["default"].imageContainer));
        images.forEach(function (image, imgIndex) {
          image.classList.remove(_ErgoTopLevelView["default"].imageContainerNoTrans);

          if (imgIndex === currentIndex) {
            image.style.opacity = 1;
          } else {
            image.style.opacity = 0;
          }
        });
      }

      var image = document.getElementById("".concat(IMAGE_ID).concat(currentIndex));

      if (image) {
        image.classList.add(_ErgoTopLevelView["default"].imageContainerNoTrans);

        if (index !== currentIndex) {
          image.style.opacity = 1 - Math.abs(index - currentIndex) * 2;
        }
      }

      var newImage = document.getElementById("".concat(IMAGE_ID).concat(newIndex));

      if (newImage) {
        newImage.classList.add(_ErgoTopLevelView["default"].imageContainerNoTrans);

        if (index !== currentIndex) {
          newImage.style.opacity = Math.abs(index - currentIndex) * 2;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "navigateToNews", function (newsId) {
      if (newsId) {
        var path = _KESI2Helper["default"].getPathToContentInTree(newsId.toString());

        var content = _KESI2Helper["default"].getContentById(newsId.toString());

        if (path) {
          if (path.length > 1 && content.type === 'nugget') {
            // Remove the last element if it was a nugget, cant link to nuggets right now
            (0, _ArrayHelper.removeElementAtPosition)(path, path.length - 1);
          }

          var stringPath = "".concat(_config["default"].baseRoute, "/").concat(path.join('!'));

          _NavigationManagerCordova["default"].goTo(stringPath);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderArrows", function (index) {
      if (!_config["default"].arrowRight || !_config["default"].arrowLeft) {
        return null;
      }

      var arrowBack = /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          _this.goToIndex(index - 1);
        },
        className: _ErgoTopLevelView["default"].arrowContainerLeft,
        style: {
          opacity: _this.state.arrowsVisible ? 1 : 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "arrow left icon",
        className: _ErgoTopLevelView["default"].arrow,
        src: _config["default"].arrowLeft
      }));

      var arrowForward = /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          _this.goToIndex(index + 1);
        },
        className: _ErgoTopLevelView["default"].arrowContainerRight,
        style: {
          opacity: _this.state.arrowsVisible ? 1 : 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "arrow right icon",
        className: _ErgoTopLevelView["default"].arrow,
        src: _config["default"].arrowRight
      }));

      if (index === 0 && _this.props.news && _this.props.news.length > 1) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErgoTopLevelView["default"].arrows
        }, arrowForward);
      } else if (index > 0 && index < _this.props.news.length - 1) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErgoTopLevelView["default"].arrows
        }, arrowBack, arrowForward);
      } else if (index > 0 && index === _this.props.news.length - 1) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErgoTopLevelView["default"].arrows
        }, arrowBack);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goToIndex", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(index) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  arrowsVisible: false,
                  newsIndex: index
                });

                _context.next = 3;
                return (0, _TimeoutHelper.timeout)(500);

              case 3:
                _this.setState({
                  arrowsVisible: true
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderNews", function (content, currentNews, index) {
      if (currentNews.length === 0) {
        return null;
      }

      return currentNews.map(function (news, index) {
        var fontColor = news.fontColor ? news.fontColor : _cssConstants["default"].colors.ergoDarkRed;
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            opacity: "".concat(_this.state.newsIndex === index ? 100 : 0),
            height: '100%',
            width: '100%'
          },
          key: "target_".concat(index)
        }, _this.state.arrowsVisible ? _this.renderArrows(index) : null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            height: '100%',
            position: 'relative'
          },
          key: "target_".concat(index)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          onClick: function onClick() {
            _this.navigateToNews(news.linkId);
          },
          className: _ErgoTopLevelView["default"].targetContainer,
          style: {
            backgroundColor: news.backgroundColor ? news.backgroundColor : _cssConstants["default"].colors.titleBackgroundOverlay
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: (0, _assign["default"])({
            color: fontColor
          }, _cssConstants["default"] && _cssConstants["default"].shield && _cssConstants["default"].shield.title ? _cssConstants["default"].shield.title : {}),
          className: _ErgoTopLevelView["default"].targetDescription
        }, news.title, _config["default"].addArrowToTileTitle && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: "arrow right icon",
          className: _ErgoTopLevelView["default"].openArrowInline,
          src: _config["default"].arrowRight
        })), _config["default"].arrowRight && !_config["default"].addArrowToTileTitle && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: "arrow right icon",
          className: _ErgoTopLevelView["default"].openArrow,
          src: _config["default"].arrowRight.replace('%23FFFFFF', "".concat(fontColor.replace('#', '%23')))
        }))));
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "filterNews", function (news) {
      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      return news.filter(function (singleNews) {
        if (!singleNews) {
          return false;
        }

        if (singleNews && !singleNews.id) {
          return false;
        }

        if (singleNews && (0, _keys["default"])(singleNews).length === 0) {
          return false;
        }

        if (!singleNews.published && !isAuthor) {
          return false;
        }

        if (!isAuthor && singleNews.showPrecondition && (0, _PreconditionChecker.getFailingPrecondition)(singleNews.showPrecondition)) {
          return false;
        }

        return true;
      });
    });
    _this.state = {
      widths: [],
      images: [],
      filePath: _CordovaFileHelper["default"].getDataFolder(),
      newsIndex: 0,
      arrowsVisible: true
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(NewsFeed.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA, _DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED]);
    return _this;
  }

  (0, _createClass2["default"])(NewsFeed, [{
    key: "renderForNews",
    value: function renderForNews(content, news) {
      var _this2 = this;

      console.log('renderForNews', content, news);

      if (content) {
        if (content.background) {
          var backgroundImage = null;

          if (_DeviceInfoHelper["default"].isBrowser()) {
            backgroundImage = content.background;
          } else {
            backgroundImage = "".concat(this.state.filePath).concat(content.background);
          }

          var subtitle = content.subtitle ? content.subtitle : null;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _ErgoTopLevelView["default"].imageContainerNoShield
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _ErgoTopLevelView["default"].targetShieldBackgroundBottomOverlay
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: _ErgoTopLevelView["default"].imageText
          }, subtitle), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
            alt: "shield background image",
            id: STATIC_IMAGE_ID,
            className: _ErgoTopLevelView["default"].targetShieldBackground,
            src: backgroundImage
          }));
        } else {
          if (news && news.length > 0 && _config["default"].isLoggedIn()) {
            return news.map(function (newsInfo, index) {
              if (!newsInfo) {
                return null;
              }

              console.log('renderForNews', newsInfo);
              var backgroundImage = null;

              if (newsInfo && newsInfo.background) {
                if (_DeviceInfoHelper["default"].isBrowser()) {
                  backgroundImage = newsInfo.background;
                } else {
                  backgroundImage = "".concat(_this2.state.filePath).concat(newsInfo.background);
                }
              }

              return /*#__PURE__*/_react["default"].createElement("div", {
                key: "".concat(IMAGE_ID).concat(index),
                id: "".concat(IMAGE_ID).concat(index),
                className: _ErgoTopLevelView["default"].imageContainer,
                style: _this2.state.newsIndex === index ? {
                  opacity: 1
                } : {
                  opacity: 0
                }
              }, _config["default"].hideGradientInShield ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
                className: _ErgoTopLevelView["default"].targetShieldBackgroundTopOverlay
              }), /*#__PURE__*/_react["default"].createElement("div", {
                className: _ErgoTopLevelView["default"].targetShieldBackgroundBottomOverlay
              })), backgroundImage && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
                alt: "shield background image",
                style: {
                  opacity: newsInfo.published ? 1 : 0.5
                },
                className: _ErgoTopLevelView["default"].targetShieldBackground,
                src: backgroundImage
              }), !newsInfo.published && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
                alt: "not visible icon",
                className: _ErgoTopLevelView["default"].notVisibleIcon,
                src: require('./assets/visible_false.svg')
              }));
            });
          } else {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: "placeholder",
              id: "placeholder",
              className: _ErgoTopLevelView["default"].imageContainer,
              style: {
                opacity: 1
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].targetShieldBackgroundTopOverlay
            }), /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].targetShieldBackgroundBottomOverlay
            }), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
              alt: "shield background image placeholder",
              className: _ErgoTopLevelView["default"].targetShieldBackground,
              src: null
            }));
          }
        }
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var className = _ErgoTopLevelView["default"].shieldContainer;

      var content = _KESI2Helper["default"].getContentById(this.props.currentId);

      var news = this.filterNews(this.props.news);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, this.renderForNews(content, news), _config["default"].isLoggedIn() && news && news.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErgoTopLevelView["default"].riskRingContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErgoTopLevelView["default"].infoContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErgoTopLevelView["default"].dotContainer
      }, news && news.length > 1 && news.map(function (singleNews, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "dot_".concat(index),
          onClick: function onClick() {
            _this3.setState({
              newsIndex: index
            });
          },
          className: _this3.state.newsIndex === index ? _ErgoTopLevelView["default"].activeDot : _ErgoTopLevelView["default"].dot
        });
      })), /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
        disabled: this.props.news && this.props.news.length <= 1,
        index: this.state.newsIndex,
        className: _ErgoTopLevelView["default"].riskRingSwipe,
        springConfig: {
          duration: '1s',
          easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
          delay: '0s'
        },
        onChangeIndex: function onChangeIndex(index, lastIndex) {
          _this3.onChangeIndex(index, news);
        },
        onSwitching: function onSwitching(index, type) {
          _this3.onSwitching(index);
        },
        slideStyle: {
          overflow: 'visible',
          margin: '0',
          width: '100%'
        },
        resistance: true,
        onTransitionEnd: function onTransitionEnd() {
          _this3.setState({
            arrowsVisible: true
          });
        }
      }, this.renderNews(content, news)))));
    }
  }]);
  return NewsFeed;
}(_DataStoreComponent2["default"]);

NewsFeed.propTypes = {
  news: _propTypes["default"].array,
  currentId: _propTypes["default"].string,
  pathArray: _propTypes["default"].array,
  goToNextPage: _propTypes["default"].func,
  showSettingsDialog: _propTypes["default"].func
};
NewsFeed.defaultProps = {
  news: []
};
var _default = NewsFeed;
exports["default"] = _default;